// ─────────────────────────────────────────────
//  native/appLock.js — biometric app-lock preference (Phase 6, D-09)
//
//  Stores the user's opt-in "require biometric unlock" choice in native
//  storage (@capacitor/preferences → SharedPreferences / UserDefaults).
//  This is a device-level UX gate only — Firebase Auth remains the source
//  of truth for identity; no credentials are ever stored here.
//
//  On web every function is a cheap no-op (lock disabled), so callers
//  never need their own platform checks.
//
//  Anesthesia Team Control (ATC)
//  Copyright © 2026 Gonzalo Martinez (gamc00@gmail.com). All rights reserved.
// ─────────────────────────────────────────────
import { isNative } from "./platform";

const KEY = "atc.biometricLock";

/** Is the biometric app-lock enabled on this device? (web → always false) */
export async function getAppLockEnabled() {
  if (!isNative()) return false;
  try {
    const { Preferences } = await import("@capacitor/preferences");
    const { value } = await Preferences.get({ key: KEY });
    return value === "true";
  } catch {
    return false; // graceful fallback: never brick the app over a pref read
  }
}

/** Persist the opt-in choice. No-op on web. */
export async function setAppLockEnabled(enabled) {
  if (!isNative()) return;
  try {
    const { Preferences } = await import("@capacitor/preferences");
    await Preferences.set({ key: KEY, value: enabled ? "true" : "false" });
  } catch {
    /* ignore — worst case the toggle doesn't stick */
  }
}
